import React from "react";
import { Link } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";

const Unauthorized: React.FC = () => {
  const { userData } = UserAuth();

  return (
    <section className="page_404">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 ">
            <div className="col-sm-10 col-sm-offset-1  text-center">
              <h1 className="not_found ">Page Not Found</h1>
              <div className="four_zero_four_bg"></div>
              <div className="contant_box_404">
                <h1 className="not_found_text">
                  Hi {userData?.name || "User"}, Look like you're lost
                </h1>
                <h1 className="not_found_text_content">
                  Sorry, the page you are looking for is not available.
                </h1>
                {userData ? (
                  <Link to="/dashboard" className="link_404">
                    Go to Dashboard
                  </Link>
                ) : (
                  <Link to="/" className="link_404">
                    Go to Home
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Unauthorized;
